import { ref, computed } from 'vue';
import { useModuleData } from '@/view/enterprise_rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';

export function useReportOverviewLogic() {
	const { report_list } = useModuleData();
	const { config, loadModuleConfig } = useModuleConfig();

	const initialized = ref(false);
	const pageData = ref([]);

	const isEmpty = computed(() => {
		return report_list.empty || !pageData.value?.length;
	});

	const tabOption = computed(() => {
		return (config.value?.tab || []).sort((a, b) => a.sort - b.sort).filter(v => v.isPublish);
	});

	async function refresh(done) {
		await loadModuleConfig('report');
		if (tabOption.value.length) {
			let allTab = tabOption.value.find(v => v.id === 'report_all' && v.isPublish);
			let rating;
			if (allTab) {
				rating = '';
			} else {
				rating = tabOption.value.map(v => v.value);
			}
			await report_list.refresh({
				pagestart: 0,
				pagenum: 20,
				rating
			});

			let data = report_list.data?.rows || [];
			data = (data || []).slice(0, 3);
			pageData.value = data;
		} else {
			report_list.loading = false;
		}

		if (!initialized.value) initialized.value = true;
		done && done();
	}

	return {
		report_list,
		pageData,
		isEmpty,
		refresh
	};
}
